import { getRequest, postRequest, putRequest, deleteRequest, patchRequest } from "../utils/axiosHandler";
import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../contexts/AuthContext";


export const testGet = async () => {
    try {
        return await getRequest("/auth/customer/test", {}, true);
    } catch (error) {
        throw error;
    }
    }
//Wishlist Start
export const addToWishlist = async (productId) => {
    try {
        //window.dispatchEvent(new Event("wishlistUpdated"));
        return await postRequest("/api/v1/wishlist", { productId }, true);
    } catch (error) {
        throw error;
    }
}

export const getWishlist = async () => {

    try {

        return await getRequest("/api/v1/wishlist", {}, true);
    } catch (error) {
        throw error;
    }
}

export const removeFromWishlist = async (productId) => {
    try {
        //window.dispatchEvent(new Event("wishlistUpdated"));
        return await deleteRequest(`/api/v1/wishlist/${productId}`, {}, true);
    } catch (error) {
        throw error;
    }
}

export const clearWishlist = async () => {
    try {
        //window.dispatchEvent(new Event("wishlistUpdated"));
        return await deleteRequest("/api/v1/wishlist", {}, true);
    } catch (error) {
        throw error;
    }
}

//wishlist end

export const addToCartAuth = async (customerId, productId, quantity) => {
    try {
        return await postRequest("/api/v1/cart", {
            id: {
                customerId: customerId,  // Include customer ID in request
                productId: productId
            },
            quantity: quantity
        }, true);
    } catch (error) {
        throw error;
    }
};

export const getCartAuth = async () => {
    try {
        return await getRequest("/api/v1/cart", {}, true);
    } catch (error) {
        throw error;
    }
};

export const updateCartAuth = async (productId, quantity) => {
    try {
        return await patchRequest("/api/v1/cart", {
            productId: productId,
            itemQuantity: quantity
        }, true);
    } catch (error) {
        throw error;
    }
};

export const deleteCartAuth = async () => {
    try {
        return await deleteRequest(`/api/v1/cart`, {}, true);
    } catch (error) {
        throw error;
    }
};

// end cart

// customer wise functions


export const getCustomer = async () => {
    try {
      return await getRequest("/api/v1/customer", {}, true);
    
    } catch (error) {
      throw error;
    }
  };
  

export const addNewAddress = async (address) => {
    try {
        return await postRequest("/api/v1/address", address, true);
    } catch (error) {
        throw error;
    }
};

export const updateCustomer = async (customer) => {
    try {
        return await putRequest("/api/v1/customer/profile", customer, true);
    } catch (error) {
        throw error;
    }
};

export const getAddresses = async () => {
    try {
        return await getRequest("/api/v1/address", {}, true);
    } catch (error) {
        throw error;
    }
};

export const updateAddress = async (address) => {
    try {
        return await patchRequest("/api/v1/address", address, true);
    } catch (error) {
        throw error;
    }
};

export const disableAddress = async (addressId) => {
    try {
        return await patchRequest(`/api/v1/address/disable/${addressId}`, {}, true);
    } catch (error) {
        throw error;
    }
};



//order functions

export const createOrder = async (order) => {
    try {
        return await postRequest("/api/v1/orders", order, true);
    } catch (error) {
        throw error;
    }
};


export const getOrders = async (page = 0, size = 5, status = '', dateFilter = '') => {
    try {
        let queryParams = `?page=${page}&size=${size}`;
        if (status) {
            queryParams += `&status=${encodeURIComponent(status)}`;
        }
        if (dateFilter) {
            queryParams += `&dateFilter=${encodeURIComponent(dateFilter)}`;
        }
       // console.log(queryParams);
        return await getRequest(`/api/v1/orders${queryParams}`, {}, true);
    } catch (error) {
        throw error;
    }
};


export const getOrderbyId = async (orderId) => {
    try {
        return await getRequest(`/api/v1/orders/${orderId}`, {}, true);
    } catch (error) {
        throw error;
    }
};

export const getCoupondetails = async (couponCode) => {
    try {
      return await getRequest(`/api/v1/coupon/check?couponCode=${couponCode}`, {}, true);
    } catch (error) {
      throw error;
    }
  };

export const getAvailableCoupons = async () => {
    try {
        return await getRequest("/api/v1/coupon/get-coupons", {}, true);
    } catch (error) {
        throw error;
    }
};